export default async function queryAll(api, predicates, options = {}) {

    let page = 1;
    let responses = [];
    options.pageSize = 100;

    while (true) {
        // set page and increase by 1 for next one 
        options.page = page++;

        const response = await api.query(predicates, options);

        if (response.results_size) {
            responses = responses.concat(response.results);
        }
        if (response.page >= response.total_pages) {
            break; 
        }
    }

    return responses;
}